import axios from 'axios';

export const companyDocumentReviewBase = (companyId: number | string) =>
  `/companies/${companyId}/document-review`;
export const getCompanyDocumentReviews = (
  companyId: number | string,
  workerId?: number
) =>
  axios.get(
    `${companyDocumentReviewBase(companyId)}${
      workerId ? `/workers/${workerId}` : ''
    }`
  );
export const reviewCompanyDocument = (
  companyId: number | string,
  workerId: number,
  documentId: number,
  input: {
    status: string;
    rejectionReason?: string;
    expiresAt?: string | null;
    expectedRevision: number;
  }
) =>
  axios.patch(
    `${companyDocumentReviewBase(
      companyId
    )}/workers/${workerId}/documents/${documentId}`,
    input
  );
export const companyDocumentFile = (
  companyId: number | string,
  workerId: number,
  documentId: number
) =>
  `/companies/${companyId}/profile/requirement-workforce/${workerId}/document-records/${documentId}/file`;

export async function openCompanyDocument(
  companyId: number | string,
  workerId: number,
  documentId: number
) {
  const opened = window.open('', '_blank');
  if (!opened) throw new Error('Allow pop-ups to view the document.');
  opened.opener = null;
  try {
    const response = await axios.get(companyDocumentFile(companyId, workerId, documentId), {responseType:'blob'});
    const url = URL.createObjectURL(response.data);
    opened.location.href = url;
    window.setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (error) {
    opened.close();
    throw error;
  }
}
